import { render, staticRenderFns } from "./ProfilePage_password.vue?vue&type=template&id=7244eb5e&scoped=true&"
import script from "./ProfilePage_password.vue?vue&type=script&lang=js&"
export * from "./ProfilePage_password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7244eb5e",
  null
  
)

export default component.exports